import React from 'react';
import { toast, Toaster } from 'react-hot-toast';
import { useWallet } from '../hooks/useWallet';
import WalletSetup from '../components/WalletSetup/WalletSetup';
import WalletDashboard from '../components/WalletDashboard/WalletDashboard';
import WalletSetupSkeleton from '../components/skeletons/WalletSetupSkeleton/WalletSetupSkeleton';

const HomePage = () => {
  const { wallet, loading, error, setupWallet, createTransaction } =
    useWallet();

  const handleWalletSetup = async (walletData) => {
    try {
      await setupWallet(walletData);
    } catch (err) {
      toast.error('Failed to setup wallet: ' + err.message);
      console.error('Failed to setup wallet:', err);
    }
  };

  const handleTransaction = async (transactionData) => {
    try {
      await createTransaction(transactionData);
    } catch (err) {
      toast.error('Failed to create transaction: ' + err.message);
      console.error('Failed to create transaction:', err);
    }
  };

  if (error && !wallet) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
        <Toaster position="top-right" />
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md w-full">
          <h2 className="text-lg font-semibold text-red-800 mb-2">Error</h2>
          <p className="text-red-600 mb-4">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <Toaster position="top-right" />
      <div className="container mx-auto py-8">
        {!wallet ? (
          loading ? (
            <WalletSetupSkeleton />
          ) : (
            <WalletSetup onWalletSetup={handleWalletSetup} loading={loading} />
          )
        ) : (
          <WalletDashboard
            wallet={wallet}
            onTransaction={handleTransaction}
            loading={loading}
          />
        )}
      </div>
    </div>
  );
};

export default HomePage;
